import CompanyAdminDevicesDataGrid from './CompanyAdminDevicesDataGrid';

export default CompanyAdminDevicesDataGrid;
